const registrationFlow = {
  stepProgress: "الخطوة {step} من {total}",
  alreadyHaveAccount: "هل لديك حساب بالفعل؟ ",
  logIn: "تسجيل الدخول",
  otp: {
    title: "التحقق",
    subtitle:
      "تحقق من حسابك وأدخل الرمز المكوّن من 4 أرقام المرسل إلى بريدك الإلكتروني",
    otpLabel: "رمز OTP",
    digitAriaLabel: "الرقم {n} من {total}",
    errors: {
      incomplete: "يُرجى إدخال الرمز المكوّن من 4 أرقام بالكامل.",
      incorrect: "الرمز الذي أدخلته غير صحيح. يُرجى المحاولة مرة أخرى.",
    },
    actions: {
      previous: "السابق",
      createAccount: "إنشاء حساب",
    },
    didNotReceive: "لم يصلك الرمز؟",
    resend: "إعادة إرسال رمز التحقق",
    resendSuccessMessage: "تم إرسال رمز التحقق إلى بريدك الإلكتروني",
    maxAttemptsReached:
      "لقد وصلت إلى الحد الأقصى لعدد المحاولات. يُرجى المحاولة مرة أخرى غدًا.",
    afterTimer: "بعد ({time})",
  },
  pending: {
    statusHighlight: "بانتظار",
    title: "التسجيل الآن\n{status} الموافقة!",
    description:
      "تم إرسال طلب التسجيل الخاص بك بنجاح! يرجى الانتظار حتى يقوم مسؤول {platformName} بمراجعة طلب تسجيل مؤسستك وقبوله.",
    platformName: "Yoram",
    emailLabel: "البريد الإشعاري",
    emailNotProvided: "غير متوفر",
  },
};

export default registrationFlow;
